package com.essntl.features.message.data.supabase.message

import com.essntl.features.itinerary.data.supabase.itinerary_service.ItineraryServiceDto
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.profile.data.supabase.ProfileDto
import com.essntl.features.profile.domain.model.ProfileModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class MessageDto(
    val id: String,
    @SerialName("user_text")
    val userText: String,
    val recipient: String,
    val type: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("sender_data")
    val sender: ProfileDto?,
    @SerialName("platform_id")
    val platformId: String?,
    @SerialName("itinerary_service_data")
    val itineraryService: ItineraryServiceDto?,
) {
    fun toModel() =
        MessageModel.empty.copy(
            id = id,
            createdAt = createdAt,
            userText = userText,
            sender = sender?.toModel() ?: ProfileModel.empty,
            platformId = platformId.orEmpty(),
            itineraryService = itineraryService?.toModel(),
            type =
            when (type.lowercase()) {
                "email" -> MessageModel.Type.Email(recipient)
                "sms" -> MessageModel.Type.Sms(recipient)
                "whatsapp" -> MessageModel.Type.Whatsapp(recipient)
                else -> throw IllegalArgumentException("Unknown message type: $type")
            },
        )

    companion object {
        private const val COLUMNS_VALUE =
            "*, sender_data:sender_id(*), itinerary_service_data:itinerary_service_id(${ItineraryServiceDto.COLUMNS_VALUE})"

        fun getColumns() =
            Columns.raw(COLUMNS_VALUE)
    }
}
